export type FulfillmentChoice = "yes" | "no";

export type OrderFulfillmentDetails = {
  wantsDelivery?: FulfillmentChoice;
  deliveryDate?: string;
  wantsRecovery?: FulfillmentChoice;
  recoveryDate?: string;
  deliveryInstructions?: string;
};

const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" && !Array.isArray(value) ? (value as Record<string, unknown>) : {};

const asChoice = (value: unknown): FulfillmentChoice | undefined =>
  value === "yes" || value === "no" ? value : undefined;

const asText = (value: unknown): string | undefined =>
  typeof value === "string" && value.trim() ? value.trim() : undefined;

const asDate = (value: unknown): string | undefined => {
  const text = asText(value);

  return text && !Number.isNaN(Date.parse(text)) ? text : undefined;
};

export const getOrderFulfillmentDetails = (metadata: unknown): OrderFulfillmentDetails | undefined => {
  const values = asRecord(metadata);
  const details = {
    wantsDelivery: asChoice(values.wants_delivery),
    deliveryDate: asDate(values.delivery_date),
    wantsRecovery: asChoice(values.wants_to_recover_items),
    recoveryDate: asDate(values.recovery_date),
    deliveryInstructions: asText(values.delivery_instructions) || asText(values.shipping_address_message),
  };

  return Object.values(details).some(Boolean) ? details : undefined;
};
